import SysAdminUserDetailsComponent from 'components/SysAdmin/SysAdminUserDetailsComponent/SysAdminUserDetailsComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import SysAdminMenu, { SysAdminMenuEnum } from 'pages/SysAdmin/SysAdminMenu/SysAdminMenu';
import { useParams } from 'react-router-dom';
import './UserDetails.css';

function UserDetails() {
  const { userId } = useParams();

  return (
    <>
      <div className="sys-admin-user-details layout-full-height">
        <Header />

        <ContainerComponent className="layout-main-content">
          <>
            <SysAdminMenu selectedMenu={SysAdminMenuEnum.USERS} />

            <SysAdminUserDetailsComponent userId={userId!} />
          </>
        </ContainerComponent>

        <Footer />
      </div>
    </>
  );
}

export default UserDetails;
